import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import THBText from 'thai-baht-text';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import pdfMake from 'pdfmake/build/pdfmake';
import { WaterMark } from 'src/app/shared/water-mark';
import { OldChulaLogo_Base64 } from 'src/app/shared/old-chula-logo-base64';
import { Signature } from 'src/app/shared/signature';
import { PaymentService } from '../payment/payment.service';
import { PaymentManagementService } from '../payment-management/payment-management.service';
import { watermarkJIP } from 'src/app/shared/watermarkJip';
import { logoJIP } from 'src/app/shared/logg-jip';

@Component({
  selector: 'lifedi-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss'],
})
export class PaymentReceiptComponent implements OnInit {
  @Input() receiptDetail: any;
  @Input() accountId: string;
  @Input() isPrint: boolean;
  @Input() isSendMail: boolean = false;
  @Input() isCopy: boolean = false;

  @Output() sendEmail = new EventEmitter();

  chulaAccount: string = '038-308312-5';
  jipAccount: string = '138-177454-2';
  address: string;
  title: string;
  textFooter: string;

  constructor(
    private paymentService: PaymentService,
    private paymentManagementService: PaymentManagementService
  ) {}

  ngOnInit(): void {
    this.getAddress();
  }

  getAddress() {
    if (this.accountId === this.chulaAccount) {
      this.address = `จุดรับเงิน: คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย
อาคารบรมราชชนนีศรีศตพรรษ ชั้น 7 แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330
โทรศัพท์: 02-218-1185 โทรสาร: 02-218-1339 เลขที่ผู้เสียภาษี: 0994000163860 สาขา: 3800`;
      this.title = 'จุฬาลงกรณ์มหาวิทยาลัย';

      this.textFooter = `(ใบเสร็จรับเงินจะมีผลสมบูรณ์ก็ต่อเมื่อได้รับชำระเงินเรียบร้อยแล้ว และมีลายชื่อของหัวหน้าหน่วยรับเงินและผู้รับเงิน)
      ถ้าชำระด้วยเช็ค ใบเสร็จรับเงินจะสมบูรณ์ก็ต่อเมื่อได้รับเงินตามเช็คนั้นเรียบร้อยแล้ว
      หมายเหตุ: จุฬาลงกรณ์มหาวิทยาลัยโดยกรมบัญชีกลางพิจารณาให้ระบบลายมือชื่ออิเล็กทรอนิกส์อยู่ในอำนาจของสภามหาวิทยาลัย
      ตามพระราชบัญญัติจุฬาลงกรณ์มหาวิทยาลัย ตามหนังสือที่ กค 0402.2/54154 ลงวันที่ 22 พฤศจิกายน 2562`;
    } else if (this.accountId === this.jipAccount) {
      this.address = `ชื่อ : บริษัท ผลิตภัณฑ์นวัตกรรมจามจุรี จำกัด
      ที่อยู่ : 254 อาคารเฉลิมราชกุมารี 60 พรรษา ชั้น 2 ถนนพญาไท แขวงวังใหม่  ปทุมวัน กรุงเทพฯ 10330 (สำนักงานใหญ่)
      โทรศัพท์: 02-218-1185 โทรสาร: 02-218-1339 เลขประจำตัวผู้เสียภาษี 0105551004146`;

      this.title = 'บริษัท ผลิตภัณฑ์นวัตกรรมจามจุรี จำกัด';

      this.textFooter = `(ใบเสร็จรับเงินจะมีผลสมบูรณ์ก็ต่อเมื่อได้รับชำระเงินเรียบร้อยแล้ว และมีลายชื่อของหัวหน้าหน่วยรับเงินและผู้รับเงิน)
      ถ้าชำระด้วยเช็ค ใบเสร็จรับเงินจะสมบูรณ์ก็ต่อเมื่อได้รับเงินตามเช็คนั้นเรียบร้อยแล้ว`;
    }

    this.createReceipt();
  }

  createReceipt() {
    this.receiptDetail.address = this.address;
    this.openPdf(this.receiptDetail);
  }

  openPdf(receipt) {
    pdfMake.fonts = {
      THsarabunNew: {
        normal: 'THSarabun.ttf',
        bold: 'THSarabunNew Bold.ttf',
        italics: 'THSarabunNew Italic.ttf',
        bolditalics: 'THSarabunNew BoldItalic.ttf',
      },
    };

    var documentDefinition = {
      background: [
        {
          image:
            this.accountId === this.chulaAccount ? WaterMark : watermarkJIP,
          width: 300,
          absolutePosition: { x: 150, y: 305 },
          opacity: 0.15,
        },
      ],
      header: [
        {
          columns: [
            [
              {
                image:
                  this.accountId === this.chulaAccount
                    ? OldChulaLogo_Base64
                    : logoJIP,
                width: 100,
                style: 'logoChulaHeader',
              },
            ],
          ],
        },
      ],
      footer: function (currentPage, pageCount) {
        return [
          {
            text: `หน้า ${currentPage.toString()} จาก ${pageCount}`,
            alignment: 'center',
          },
        ];
      },
      content: [
        // header
        {
          columns: [
            {
              stack: [
                `เลขที่ใบเสร็จรับเงิน ${receipt.receiptId}`,
                // `เลขที่เอกสาร ${receipt.paymentID}`,
                `วันที่ชำระเงิน ${receipt.date}`,
                this.isCopy ? '(สำเนา)' : '(ต้นฉบับ)',
              ],
            },
          ],
          style: 'receiptHeader',
        },
        {
          columns: [
            [
              {
                text: this.title,
                style: 'textHeader',
              },
              {
                text: 'ใบเสร็จรับเงิน',
                style: 'subTextHeader',
              },
              {
                text: receipt.address,
                style: 'addressHeader',
              },
            ],
          ],
        },
        {
          columns: [
            [
              {
                text: `ได้รับเงินจาก     ${
                  receipt.userName ? receipt.userName : '-'
                }`,
                width: 30,
                style: 'userDetail',
              },
            ],
          ],
        },
        {
          columns: [
            {
              stack: [
                `เลขประจำตัวผู้เสียภาษี     ${
                  receipt.taxID ? receipt.taxID : '-'
                }`,
                `ที่อยู่     ${
                  receipt.userAddress ? receipt.userAddress : '-'
                }`,
              ],
              width: 200,
            },
          ],
          style: 'userSubDetail',
        },
        {
          table: {
            headerRows: 1,
            widths: [380, 120],
            heights: [0, 200, 0],
            style: 'table',

            body: [
              [
                {
                  text: 'รายการ',
                  style: 'tableHeader',
                },
                {
                  text: 'จำนวนเงิน (บาท)',
                  style: 'tableHeader',
                },
              ],
              [
                {
                  text: receipt.paymentName,
                  style: 'tableName',
                },
                {
                  text: receipt.price.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  }),
                  style: 'tablePrice',
                },
              ],
              [
                {
                  text: 'รวมเงิน',
                  style: 'tableFooter',
                },
                {
                  text: receipt.price.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  }),
                  style: 'tableFooter',
                },
              ],
            ],
          },
        },
        {
          columns: [
            {
              text: `จำนวนเงินรวม (ตัวอักษร) ${receipt.thbath}`,
              style: 'amountTH',
            },
          ],
        },
        {
          columns: [
            {
              // text: `รับชำระโดย  (${receipt.type}) ธ. ไทยพาณิชย์ จำกัด (มหาชน) 0382583415`,
              text: `รับชำระโดย (${receipt.type}) ธ. ไทยพาณิชย์ จำกัด (มหาชน) ${
                receipt.type === '2C2P' ? receipt.cardNo : this.accountId
              }`,
              style: 'amountTH',
              width: 320,
            },
            {
              text: receipt.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              style: 'amountTH',
              width: 50,
            },
            {
              text: `วันที่ ${
                receipt.bankDate.getDate() > 9 ? '' : 0
              }${receipt.bankDate.getDate()}.${
                receipt.bankDate.getMonth() + 1 > 9 ? '' : 0
              }${receipt.bankDate.getMonth() + 1}.${
                receipt.bankDate.getFullYear() + 543
              }`,
              style: 'amountTH',
            },
          ],
        },
        {
          columns: [
            // style: ''
            [
              {
                image: receipt.signaturePic1,
                width: 100,
                height: 25,
                style: 'signatureImg',
              },
              {
                text: '_________________________',
                width: '*',
                style: 'NameSignatureFooter',
              },
              {
                text: receipt.signatureJobTitle1,
                // text: receipt.signatureJobTitle,
                width: '*',
                style: 'NameSignatureFooter',
              },
              {
                text: `(${receipt.signatureName1})`,
                width: '*',
                style: 'NameSignatureFooter',
              },
            ],
            [
              {
                text: '', // blank column
              },
            ],
            [
              {
                text: '', // blank column
              },
            ],
            [
              {
                image: receipt.signaturePic2,
                width: 100,
                height: 25,
                style: 'signatureImg',
              },
              {
                text: '_________________________',
                width: '*',
                style: 'NameSignatureFooter',
              },
              {
                // text: receipt.signatureJobTitle,
                text: receipt.signatureJobTitle2,
                width: '*',
                style: 'NameSignatureFooter',
              },
              {
                text: `(${receipt.signatureName2})`,
                width: '*',
                style: 'NameSignatureFooter',
              },
            ],
          ],
        },
        {
          columns: [
            [
              {
                text: this.textFooter,
                alignment: 'center',
                margin: [0, 10, 0, 0],
              },
              {
                text: `พิมพ์เมื่อ: ${receipt.printDate}`,
                alignment: 'left',
                margin: [0, 10, 0, 0],
              },
            ],
          ],
        },
      ],
      styles: {
        logoChulaHeader: {
          margin: [0, 35, 0, 5],
          alignment: 'center',
        },
        receiptHeader: {
          margin: [0, -5, 0, 5],
          alignment: 'right',
          // color: '#A5A5A5'
        },
        textHeader: {
          margin: [0, 20, 0, 0],
          alignment: 'center',
          fontSize: 20,
          bold: true,
        },
        subTextHeader: {
          margin: [0, -5, 0, 0],
          alignment: 'center',
          fontSize: 18,
          bold: true,
        },
        addressHeader: {
          margin: [0, 5, 0, 0],
          alignment: 'center',
          // fontSize: ,
        },
        userDetail: {
          margin: [0, 10, 0, 15],
          alignment: 'left',
          bold: true,
        },
        userSubDetail: {
          margin: [0, 0, 0, 15],
          alignment: 'left',
          bold: true,
        },
        tableHeader: {
          margin: [0, 0, 0, 0],
          bold: true,
          fontSize: 13,
          alignment: 'center',
        },
        tableName: {
          margin: [5, 5],
          fontSize: 13,
          alignment: 'left',
        },
        tablePrice: {
          margin: [5, 5],
          fontSize: 13,
          alignment: 'right',
        },
        tableFooter: {
          margin: [0, 0, 5, 0],
          fontSize: 13,
          alignment: 'right',
        },
        amountTH: {
          margin: [0, 0, 0, 0],
          // fontSize: 15,
          alignment: 'left',
          bold: true,
        },
        signatureImg: {
          margin: [0, 60, 0, 0],
          alignment: 'center',
        },
        NameSignatureFooter: {
          margin: [0, 0, 0, 0],
          alignment: 'center',
          bold: true,
        },
      },
      defaultStyle: {
        columnGap: 20,
        font: 'THsarabunNew',
      },
      info: {
        title: receipt.paymentID,
        fileName: receipt.paymentID,
      },
    };

    if (this.isSendMail) {
      var pdfDocGenerator = pdfMake.createPdf(documentDefinition);
      pdfDocGenerator.getBase64((base64) => {
        this.sendEmail.emit(base64);
      });
    } else {
      // pdfMake.createPdf(documentDefinition).open();

      var pdfDocGenerator = pdfMake.createPdf(documentDefinition);
      //   pdfDocGenerator.getDataUrl((dataUrl) => {
      //     var link = document.createElement('a');
      //     link.href = dataUrl;
      //     link.target = '_blank';
      //     document.body.appendChild(link);
      //     link.click();
      //     document.body.removeChild(link);
      // });

      pdfDocGenerator.getBase64((base64) => {
        const pdfBlob = base64ToBlob(base64, 'application/pdf');
        console.log('pdfBlob',pdfBlob)
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // เปิดไฟล์ PDF บนเบราว์เซอร์ใหม่
        window.open(pdfUrl, '_blank');
      });
    }

      function base64ToBlob(base64, type = 'application/octet-stream') {
        const binStr = atob(base64);
        const len = binStr.length;
        const arr = new Uint8Array(len);
    
        for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
        }
    
        return new Blob([arr], { type: type });
    }
  }
}
